import { render, staticRenderFns } from "./SoKetChuyenTienMat.vue?vue&type=template&id=351ea8be"
import script from "./SoKetChuyenTienMat.vue?vue&type=script&lang=js"
export * from "./SoKetChuyenTienMat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports